export type ReferralRequest = {
  host: string;
};
export type ReferralResponse = {
  statusCode: number;
  id: number;
  invitationLink: string;
  createdAt: string;
  updatedAt: string;
};

export type ReferralState = {
  invitationLink: string;
  referralList: ReferralItemType[];
  total: number;
  lastPage: number;
  enabled: boolean;
  success: null | boolean;
  status: REFERRAL_STEPS;
  amount: string;
  error: string;
};

export type ReferralListRequest = {
  take: number;
  page: number;
};
export type ReferralListResponse = {
  statusCode: number;
  items: ReferralItemType[];
  total: number;
  lastPage: number;
};

export type ReferralItemType = {
  referralId: number;
  referrerId: number;
  profit: number;
  removalReason?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type WithdrawalResponse = {
  statusCode: number;
  message: string;
  errorCode: string;
  timestamp: string;
};

export type ReferralWithdrawalRequest = {
  amount: number;
};

export type ReferralWithdrawalResponse = {
  statusCode: number;
  message: NonNullable<unknown>;
  referralBalance: number;
  success: boolean;
};

export enum REFERRAL_STEPS {
  AMOUNT,
  LOADING,
  SUCCESS,
  FAILED,
}
